// extracted by mini-css-extract-plugin
module.exports = {"page":"delta-3-portable-power-station_page__nmRSu","spin":"delta-3-portable-power-station_spin__yNSdC"};